<template>
  <div class="container relative max-w-screen-md copy-text-wrapper">
    <div
      class="font-light leading-normal break-words text-copy fluid-lg"
      :class="[{ 'px-4 md:px-8 py-6 md:py-8 bg-putty': copyTextLayout === 'boxed' }, bodyClass]"
      v-html="body"
    ></div>
    <div v-if="relatedEntry" class="related">
      <div class="flex flex-row items-center justify-between">
        <div class="py-4 mr-auto font-medium fluid-sm leading-tightest" aria-hidden="true">
          {{ $t('copyTextrelated') }}
        </div>
        <nuxt-link
          :to="{ path: $localeRootPath(relatedEntry.uri) }"
          class="block hover:text-br-green"
          :aria-label="$t('copyTextrelated')"
        >
          <ArrowIcon class="transform rotate-180 h-2.5" />
        </nuxt-link>
      </div>
      <nuxt-link :to="{ path: $localeRootPath(relatedEntry.uri) }" class="block">
        <FixedAspect :ratio="2 / 3">
          <CldnImg
            v-if="relatedEntryImage"
            :src="relatedEntryImage.url"
            :alt="relatedEntryImage.title"
            sizes="100vw sm:100vw md:100vw lg:280px xl:280px 2xl:280px"
            crop="fill"
          />
        </FixedAspect>
      </nuxt-link>
      <div class="mt-4 font-medium fluid-sm leading-tightest">{{ relatedCaption }}</div>
    </div>
  </div>
</template>

<script>
import CldnImg from '@/components/CldnImg';
import FixedAspect from '@/components/common/FixedAspect';
import ArrowIcon from '@/components/icons/ArrowIcon';

export default defineNuxtComponent({
  components: {
    CldnImg,
    FixedAspect,
    ArrowIcon,
  },
  props: {
    body: {
      type: String,
      default: '',
    },
    relatedCaption: {
      type: String,
      default: '',
    },
    related: {
      type: Array,
      default: () => [],
    },
    relatedImage: {
      type: Array,
      default: () => [],
    },
    copyTextLayout: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'boxed'].includes(value),
    },
  },
  computed: {
    relatedEntry() {
      return this.related ? this.related[0] : null;
    },
    bodyClass() {
      if (this.body && (this.body.includes('<ul>') || this.body.includes('<ol>'))) {
        return 'checkmark-bullets checkmark-noborder';
      }
      return '';
    },
    relatedEntryImage() {
      if (this.relatedImage && this.relatedImage.length) {
        return this.relatedImage[0];
      }

      return this.relatedEntry && this.relatedEntry.image && this.relatedEntry.image[0]
        ? this.relatedEntry.image[0]
        : null;
    },
  },
});
</script>
<style scoped>
@reference "~/assets/css/main.css";
.copy-text-wrapper {
  @apply my-4;
}

.related {
  @apply lg:absolute lg:bottom-0;
}

@media (width >= 1024px) {
  .related {
    margin-left: 100%;
    width: 11vw;
  }
}

@media (width >= 1280px) {
  .related {
    width: 15vw;
  }
}

.copy-text-wrapper :deep(blockquote) {
  @apply lg:-ml-20;
}

@media (width >= 1024px) {
  .copy-text-wrapper :deep(blockquote) {
    font-size: calc(3.125rem - 10px);
  }
}
</style>
